<template>
    <div>
        <web-modal id="call">    
            <template slot="content">
                <figure>
                    <img loading="lazy" src="/imgs/web/radka_lg.webp" srcset="/imgs/web/radka_lg.webp 1x, /imgs/web/radka_lg@2x.webp 2x" alt="">
                    <span v-if="isOnline" class="online"></span>
                </figure>
                
                <strong class="new-headline-sm text-centered">Sie wissen nicht, was Sie jetzt tun sollen?</strong>
                <p class="new-text-md text-centered">Hinterlassen Sie uns Ihre Telefonnummer und wir kontaktieren Sie umgehend.</p>
                <form id="ask-for-call" action="" method="POST" @submit.prevent="submit" novalidate>
                    <form-input-type-phone-number
                        name="phone"
                        label="Telefonnummer"
                        phoneCountry="de"
                        :errors="errors.phone"
                        full-border
                        required
                    ></form-input-type-phone-number>
                    
                    <form-input-type-select
                        name="call-modal"
                        label="Wählen Sie Ihr Anliegen aus"
                        :options="selectOptions"
                        :errors="errors.call"
                        full-border
                        required
                    ></form-input-type-select>

                    <v-button type="submit" label="Rufen Sie mich bitte an" icon="material-symbols-rounded.phone" full-width/>
                </form>

                <p class="new-text-sm text-centered">Wir verarbeiten die Daten in Übereinstimmung mit der <a :href="getUrl" target="_blank">Richtlinie zur Verarbeitung personenbezogener Daten</a> zum Zweck eines einmaligen telefonischen Kontakts mit Informationen über unsere Dienstleistungen.</p>
            </template>
        </web-modal>

        <flash-alert v-if="showAlert" @closeAlert="close" text="Danke, wir werden Sie in Kürze anrufen, um alles zu besprechen." position="top"></flash-alert>
    </div>
</template>

<script>
    export default {
        props: {

        },
        data() {
            return {
                errors: {},
                showAlert: false
            }
        },
        mounted() {
            
        },
        computed: {
            isOnline() {
                if(moment().format("d") != 5 && moment().format("d") != 6 && moment().format("HH:mm") < moment("17:00", "HH:mm").format("HH:mm") && moment().format("HH:mm") > moment("09:00", "HH:mm").format("HH:mm")) {
                   return true
                }
                
                return false
            },
            getUrl() {
                let uri = new URI(location.href)

                if(uri.domain() === 'abnehmenmitdiabetes.de') {
                    return "https://vitadio.de/datenschutzerklarung"
                } else {
                    return "/datenschutzerklarung"
                }
            },
            selectOptions() {
                return [
                    { label: 'Ich habe eine allgemeine Frage zu Vitadio' },
                    { label: 'Mein Code funktioniert nicht' },
                    { label: 'Ich kann mich nicht einloggen' },
                    { label: 'Ich kann mein Rezept nicht hochladen' },
                    { label: 'Die Verifizierungs-SMS ist nicht angekommen' },
                    { label: 'Sonstiges' }
                ]
            },
        },
        methods: {
            submit() {
                let formData = {}

                // serialize form data
                $("#ask-for-call")
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                formData['call'] = formData['call-modal']

                axios
                    .post('api/ask-for-call', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        window.location.href = '/call-success'
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },

            close() {
                this.showAlert = false
            }
        }
    }
</script>
